
// Import css files

import hammer from '../../../../../assets/images/hammer.png';
import React, { useEffect } from 'react';
import { Link } from "react-router-dom";
import question from '../../../../../assets/images/askqsblog.svg';
import bankingicon from '../../../../../assets/askTheExpertImages/bankingmenuicon.svg';
import { convertToCanadianDateTime, convertToRoman, decodeHtmlEntities } from "../../../../../shared/helper";
import expiryclock from '../../../../../assets/images/expiryclock.svg';
import stillunsure from '../../../../../assets/images/stillunsure.svg';
import askimg from "../../../../../assets/homeimages/askbtn.svg";
import { Trans, useTranslation } from "react-i18next";
import TextWithBreaks from '../../../../../shared/lineBreak';
const BankingArticleDetailsV3Jsx = (props) => {
  const {
    detailsData
  } = props;
  const { t } = useTranslation();
  useEffect(() => {
   
    window.scrollTo(0, 0);
  }, [])
  return (
    <>

<section className="bankinversionthreedetailblog">
        <div className="container">
          <div className="blogsectioone">
            <div className="row">
              <div className="col-lg-7 col-sm-7">
                <div className="blogsectiooneleft">
              
                  <div className="blogsectioleft">
                  <div className="tagreal d-block d-lg-none d-sm-none d-md-none "><span><img src={bankingicon} alt="Banking Icon" /></span>{detailsData?.['_embedded']?.['wp:term']?.[0]?.[0]?.name}</div>
                    <div className="title">
                      <h1>{decodeHtmlEntities(detailsData?.title?.rendered)}</h1></div>
                      <div dangerouslySetInnerHTML={{ __html: detailsData?.acf?.variant_3?.banner_sectionn?.short_description }}></div>                    
                  </div>
                  
                <div className="anptag"><p>{detailsData?.acf?.variant_3?.banner_sectionn.description }</p></div>
                <div className="d-flex userdetails">
                    <div className="userphoto">
                      <img src={`https://ui-avatars.com/api/?name=${detailsData?.['_embedded']?.['author']?.[0]?.name}&rounded=true`} alt={`${detailsData?.['_embedded']?.['author']?.[0]?.name}`} />
                    </div>
                    <div className="username">{detailsData?.['_embedded']?.['author']?.[0]?.name}</div>
                  </div>
                  </div>
              </div>
              <div className="col-lg-5 col-sm-5">
                <div className="blogsectioright">
                <div className="tagreal d-none d-sm-block d-sm-flex"><span><img src={bankingicon} alt="Banking Icon" /></span>{detailsData?.['_embedded']?.['wp:term']?.[0]?.[0]?.name}</div>
                  <img src={detailsData?.acf?.variant_3?.banner_sectionn?.image} alt="bannerimage" />
                   <p className="articlepublishdate mt-2"><span><img src={expiryclock} alt="clock" /></span>{convertToCanadianDateTime(detailsData?.date)}</p>
                </div>
               
              </div>
            </div>

          </div>
          <div className="blogsectiontwo">
            <div className="row">
              <div className="col-lg-4 col-sm-4">
                <div className="psnapshot">
                  <h2>Product Snapshot</h2>
                  <table className="table psnapshotin">
                    {detailsData?.acf?.variant_3?.product_snapshot.map((item,index) => (
                   <tr key={index}>
                     <td>{convertToRoman(index+1)}</td>
                     <td>{item?.title}:</td>
                     <td>{item?.value}</td>
                   </tr>
                   ))}
                  
                  </table>
                </div>
              </div>
              <div className="col-lg-4 col-sm-4">
                <div className="prosinner">
                  <ul>
                  {detailsData?.acf?.variant_3?.product_pros.map((item,index) => (
                    <li key={index}>{item?.title}</li>
                    ))}
                   
                  </ul>
                </div>
              </div>
              <div className="col-lg-4 col-sm-4">
                <div className="prosinner consinner">
                  <ul>
                  {detailsData?.acf?.variant_3?.product_cons.map((item,index) => (
                    <li key={index}>{item?.title}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="blogsectionthree">
            <div className="row">
              <div className="col-lg-3 col-sm-3">
                <h2>{detailsData?.acf?.variant_3?.features_section?.title}</h2>
              </div>
              <div className="col-lg-9 col-sm-9">
                <div className="blogsectionthreeright">
                  <div className="row">

                  {detailsData?.acf?.variant_3?.features_section?.features.map((item,index) => (
                    <div className="col" key={index}>
                      <div className="col-inner">
                        <div className="slnumber">{index+1}</div>
                        <div className="col-innerts">
                          <h4>{item?.title}</h4>
                          <p>{item?.description}</p>
                        </div>
                      </div>
                    </div>

                    ))}
                    
                  
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="blogsectionfour">
            <div className="row">
              <div className="col-lg-9 col-sm-9">
                <div className="blogsectionfourinner">
                <h2>{detailsData?.acf?.variant_3?.ease_section?.title}</h2>
                  <div className="row">

                  {detailsData?.acf?.variant_3?.ease_section?.usecases.map((item,index) => (
                  <div className="col-lg-4 col-sm-4"  key={index}>
                  <div className="blogsectionfourleftinner">
                    <h4>{item?.title}</h4>
                    {item?.description_points && item?.description_points.map((iteminr,index) => (
                        <p key={index}>{iteminr?.point}</p>
                    ))}
                    
                  </div>
                  </div>

                  ))}


                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-sm-3">
                <h3>{detailsData?.acf?.variant_3?.conclusion_section?.title}</h3>
                <img src={hammer} className="hammer" alt={hammer}/>
                <div > <TextWithBreaks text={detailsData?.acf?.variant_3?.conclusion_section?.description} /></div>                
                
              </div>
            </div>
          </div>
          <div className="blogsectionfive">
            <div className="row">
              <div className="col-lg-3 col-sm-3" style={{
                backgroundImage:`url(${detailsData?.acf?.variant_3?.value_for_money?.image})`
              }}>
                <h2>{detailsData?.acf?.variant_3?.value_for_money?.title}</h2>
              </div>
              <div className="col-lg-9 col-sm-9">
                <div className="blogsectionfiveright">
                  <div className="row">

                  {detailsData?.acf?.variant_3?.value_for_money?.item.map((item,index) => (
                    <div className="blogsectionfiverightinner" key={index}>
                      <span>{String.fromCharCode(65 + index)}</span>
                      <p>{item?.description}</p>
                    </div>
                  ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="blogsixsection mt-5">
            <div className="d-flex blogsixsectioninner align-items-center">
              <div className="col-lg-2 col-sm-2"><img src={question} alt="blogicon" /></div>
              
              <div className="col-lg-10 col-sm-10">
             <div className="mb-4"><img src={stillunsure} alt="stillicon" /></div> 
              <p><Trans i18nKey={t("COMMON.BLOGV3TEXT")}></Trans></p>
              <div className="blogsixsectioninnerbtn">
                <Link to={'/AskTheExpert'}>
                  <div className={`askbutton`}>
                    <p className={`askres mb-0`}>{t("COMMON.ASKTHEEXPERTS")}</p>
                    <img src={askimg} alt="Ask now" />
                  </div>
                </Link>
              </div>
              </div>
             
            </div>
          </div>
          <div className="blogdisclaimer">
       <div className="disclaimerinner">
         <h2>{t("COMMON.Disclaimer_heading")}</h2>
         <p>{t("COMMON.Disclaimer_text")}</p>
       </div>
       </div>
        </div>
      </section>
    </>

  );
};

export default BankingArticleDetailsV3Jsx;